export default {
  'm': {
    'EnterID': 'Fare clic per inserire l\'ID BuzzCast',
    'select-specifications': 'Fare clic per selezionare le specifiche di ricarica',
    'check-account': 'Controlla il conto di ricarica',
    'whatID': 'Che cos\'è un ID BuzzCast?',
    'getID': 'Inserisci l\'ID BuzzCast',
    'maskgetID': 'Inserisci l\'ID BuzzCast',
    'toastTips-format-error': 'Formato di input errato',
    'toastTips-no-exist': 'L\'ID non esiste',
    'toastTipsPlease': 'Si prega di controllare prima il conto di ricarica',
    'common-problem': 'Problema comune',
    'transaction-succeeded': 'Commercio di successo',
    'transaction-failed': 'Transazione fallita',
    'transaction-cancel': 'Annullamento della transazione',
    'whether-account': '1.Come posso verificare se è presente nell\'account dopo averlo ricaricato?',
    'answer-whether-account': 'Dopo la ricarica, puoi tornare a [Mio] - [portafoglio] dell\'app per visualizzare i diamanti',
    'no-account': '2.Cosa devo fare se non mi pagano dopo la ricarica?',
    'answer-no-account': 'Invia le tue domande in [messaggio] - [messaggio ufficiale] - [feedback e guida] dell\'app e fornisci le seguenti informazioni. Il nostro servizio clienti ti aiuterà.',
    'recharge-money': '1. Ricarica l\'importo e l\'ID conto',
    'recharge-time': '2. Ora e data della ricarica',
    'recharge-shot': '3. Schermata del pagamento riuscito',
    'recharge-wrong': '3.Come addebitare l\'account e l\'importo errati',
    'answer-recharge-wrong': 'Prima di inserire la password di pagamento, si prega di confermare con attenzione l\'ID dell\'account di ricarica e le informazioni sull\'importo della ricarica prima dell\'acquisto. L\'importo addebitato non può essere restituito. Per l\'account addebitato, puoi provare a contattare l\'utente ID della ricarica effettiva e negoziare con l\'altra parte se sei disposto a compensare la ricarica.',
    'refund': '4.Rimborso',
    'answer-refund': 'Mi dispiace! BuzzCast al momento non supporta alcuna forma di rimborso.',
    'buy-enter-link': 'I diamanti possono essere ricaricati tramite il link, <a class="web-link" href="https://pay.buzzcast.info">https://pay.buzzcast.info</a> Copia il link e aprilo nel browser mobile, accedi alla pagina di acquisto, controlla il numero di conto, seleziona le specifiche corrispondenti e usa il metodo di pagamento appropriato per pagare - più sconti!',
    'buy-notice-a': 'Nota:<a>{msg}</a> è l\'unico sito ufficiale di BuzzCast per l\'acquisto di diamanti',
    'replace': 'Sostituire',
    'sureBtn': 'OK',
    'pay-style': 'Scegli il metodo di pagamento',
    'goBack': 'Torna alla homepage',
    'toastTips': 'Inserisci l\'ID BuzzCast',
    'rechargeFAQ_title': 'Problema comune',
    'PayStatusSuccess_title': 'Commercio di successo',
    'PayStatusFail_title': 'Transazione fallita',
    'PayStatusCancel_title': 'Annullamento della transazione',
    'Diamonds_title': 'Sito ufficiale di ricarica diamante {msg}',
    'buy-notice': 'Nota: pay.buzzcast.info è l\'unico sito ufficiale di acquisto di diamanti di BuzzCast, si prega di andare a The Message - Official News - Feedback and Help',
    'RechargeHelp_title': 'Ricarica aiuto',
    'openAPP': 'Apri l\'APP BuzzCast',
    'buy-diamonds-tit': 'Acquista servizi di diamanti',
    'description': 'BuzzCast è l\'unico sito ufficiale di ricarica di diamanti. BuzzCast è un social software internazionale. Gli utenti in oltre 150 paesi e regioni utilizzano il BuzzCast',
    'keywords': 'Ricarica BuzzCast, ricarica diamante BuzzCast, ricarica ufficiale BuzzCast, sito web ricarica ufficiale BuzzCast',
    'payforType': 'Metodo di ricarica',
    'trueText': 'OK',
    'falseText': 'Annullare',
    'alertShowTxt1': 'Sei sicuro di utilizzare',
    'alertShowTxt3': 'Per ricaricare',
    'alertShowTxt5': 'diamanti?',

    'EnterIDTip': 'Ricarica rapida {msg}',


    'scanLogin': 'Per la privacy e la sicurezza dell\'account, scansiona il codice per accedere',
    'scanTip': 'Suggerimento: fai clic su "Scansiona" nell\'angolo in alto a destra di BuzzCast "Centro personale / Dinamica" per scansionare il codice per accedere. Allo stesso tempo, supporta l\'accesso identificando lo screenshot del codice QR',
    'scanVersion': 'Aggiorna BuzzCast alla versione %s e scansiona il codice per accedere',
    'delAccount': 'Cancellazione dell\'account',
    'logout': 'Disconnessione',
    'submit': 'Inviare',
    'email_place_holder': 'Inserisci la tua casella di posta',
    'contact_email': 'Contatto email',
    'provide_email': 'Fornisci il tuo indirizzo email per ricevere la notifica di pagamento',
    'email_address': 'Indirizzo e-mail',


    'sel_country_area': "Seleziona Paese o Regione",
    'search_for': "Ricerca",
    'login': "Accesso",
    'scan_login': "Login del codice di scansione",
    'account_password_error': "Numero di telefono o password errati",
    'user_frozen': "L'utente è stato congelato",
    'account_no_reg': "L'account non è registrato",
    'login_no': "Non sei loggato",
    'login_after_recharge': "Puoi ricaricare dopo aver effettuato l'accesso",
    'scan_login_lesson': "Tutorial del login del codice di scansione",
    'scan_login_desc': "Il metodo del login del codice di scansione può rendersi conto in modo rapido e sicuro per accedere al sito Web di ricarica. I seguenti due metodi introdurranno rispettivamente come eseguire la scansione del codice per il login.",
    'scan_login_a_title': "Accedi riconoscendo gli screenshot del codice QR",
    'scan_login_a_p1': "1. È più adatto per l'utilizzo dello scenario del singolo dispositivo. L'utente inserisce la pagina di accesso del sito Web di ricarica, fare clic per selezionare \"Codice di scansione per accedere\" e prendere lo screenshot della pagina con il codice QR di accesso viene visualizzato e salva l'album. (La funzione Screenshot è leggermente diversa per diversi dispositivi, è possibile cercare le istruzioni operative della funzione Screenshot da soli)",
    'scan_login_a_p2': "2. Aprire l'app FacCast, attraverso il modulo funzione \"Centro personale\" o \"Dinamico\", fare clic su \"Scansione\" nell'angolo in alto a destra per immettere il modulo di funzione di scansione del codice.",
    'scan_login_a_p3': "3. Fare clic su \"Selezione dell'album\" e consentire alle autorizzazioni dell'album, selezionare lo screenshot della pagina di accesso del codice QR salvato, fare clic sul pulsante di conferma \"Accedi\" dopo il riconoscimento del sistema, tornare al browser e attendere un po ', la pagina carica automaticamente l'utente informazione.",
    'scan_login_b_title': "Accedi Scansione del codice QR",
    'scan_login_b_p1': "1. È più adatto per l'uso di più dispositivi. L'utente inserisce la pagina di accesso del sito Web di ricarica e fai clic per selezionare \"Accesso del codice di scansione",
    'scan_login_b_p2': "2. Aprire l'app FacCast su un altro dispositivo, vai al modulo \"Centro personale\" o \"Dinamico\" e fare clic su \"Scansione\" nell'angolo in alto a destra per accedere al modulo funzione di scansione del codice.",
    'scan_login_b_p3': "3. Allineare la casella di scansione del codice con il codice QR nella pagina di accesso della scansione del codice, fare clic sul pulsante di conferma \"Login\" dopo che il sistema lo riconosce (si consiglia di mantenere una certa distanza tra i dispositivi quando si esegue la scansione del codice, che è più facile per il sistema da riconoscere). Dopo un po ', la pagina carica automaticamente le informazioni dell'utente.",
    'scan_login_lesson_end': "Quanto sopra è una guida tutorial per il login del codice di scansione, spero di aiutarti. Per la consultazione del servizio clienti, inserisci il messaggio dell'app-notizie ufficiali-il feedback e l'aiuto.",
    'or': "o",
    'input_phone_num': "Il numero di telefono non può essere vuoto",
    'input_email': "Inserisci il tuo indirizzo email",
    'input_password': "Inserire la password",

    'log_in_using_Facebook': 'Fai il login con Facebook',
    'log_in_using_Google': 'Accedi con Google',
    'account_or_pwd_error': 'Account o password errati',

    'pay_fail_system_risk': 'Transazione non riuscita: sistema anomalo',

    'friendly_tip': 'Suggerimento caldo',
    'i_got_it': 'Ho capito',
    'android_fblogin_tip': 'Poiché Facebook non supporta più l\'accesso con autenticazione sul browser integrato di Android, potresti non essere in grado di accedere quando accedi in questo modo. Se riscontri questo tipo di problema di accesso, utilizza il browser Chrome per accedervi.',
    'recharge_tip': 'L\'importo specifico di diamanti è stato sul conto è soggetto all\'importo effettivo di ricarica',

    'charge': 'Ricarica',
    'link_add_mainpage': 'Aggiungi un collegamento alla schermata iniziale per la tua prossima ricarica',
    'click_me_to_add': 'Fare clic su di me per aggiungere',

    'user_has_delete': 'L\'utente è stato annullato',

    'support_contant_whatsapp': 'Se hai bisogno di supporto, contatta il servizio clienti su {msg} App：1924383',


    'buy_balance': 'Saldo acquistabile:',
    'official_coin_seller': 'Commerciante ufficiale di monete',
    'paystyle_unavailabel_change_other': 'Il sistema è anomalo, questo metodo di pagamento è temporaneamente non disponibile, puoi passare ad altri metodi di pagamento.',

    'failedPay': 'Il pagamento ha riscontrato un problema, effettuare un nuovo pagamento',
    "copied": "Copiato",
    "reseller": "Rivenditore",
    "netword_busy_try": "La rete è occupata, riprova",
    "placecommen": 'Inserisci le parole di ricerca',
    "app_all_v2": 'Tutti',

		"use_phone_login": `Accedi con telefono`,
		"use_email_login": `Accedi con email`,
    "device_is_more": "Il numero di account registrati per questo dispositivo ha raggiunto il limite massimo",
    "Operation_failed": "Questo dispositivo è stato bloccato in modo permanente a causa di violazioni dell'account",
    "bondo_pay_tip": "The recharged balance can only be used in the app. Download and open the app to use your balance to unlock and watch paid episodes",
    "bondo_pay_success_tip": "Download Bondo from the App Store and sign in to both the app and the website with the same account. Once completed, any balance topped up on the website can be used in the app to unlock paid short-drama episodes",
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/it.js